import { useCallback, useEffect, useState } from "react";
import { getPricingSettings } from "../../../api/marketplacePricingApi";

// Режим цены и прибыль по умолчанию аккаунта — для бейджа вкладки и подсказок
// в таблицах отправителей. Ошибки глушим: это вспомогательная информация.
export default function useMarketplacePricingMode(platform, accountId) {
    const [state, setState] = useState({ mode: null, defaultProfit: null });

    const reload = useCallback(async () => {
        if (!accountId) {
            setState({ mode: null, defaultProfit: null });
            return;
        }
        try {
            const data = await getPricingSettings(platform, accountId);
            setState({
                mode: data?.pricing_mode || "legacy",
                defaultProfit: data?.exists ? data.default_supplier_profit_uah : null,
            });
        } catch (error) {
            setState({ mode: null, defaultProfit: null });
        }
    }, [platform, accountId]);

    useEffect(() => {
        reload();
    }, [reload]);

    return { ...state, reload };
}

export const profitPlaceholder = (defaultProfit) =>
    defaultProfit !== null && defaultProfit !== undefined && defaultProfit !== ""
        ? `по умолч. ${Number(defaultProfit).toLocaleString("uk-UA")}`
        : "по умолч. аккаунта";
